module.exports = __webpack_public_path__ + "img/h-banner13.51c55cdd.jpg";